import { render, staticRenderFns } from "./HostServers.vue?vue&type=template&id=21c6192d"
import script from "./HostServers.vue?vue&type=script&lang=js"
export * from "./HostServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports